import React from "react";
import Spinner from "../../atoms/common/spinner/spinner";
import Tag, {TagType} from "../../atoms/tag/tag";
import "./residentMetricCard.sass";
import classNames from "classnames";

export interface IResidentMetricCardProps {
  title: string;
  description: string;
  metricValue: string;
  metricPercent: number | undefined;
  tagType: TagType;
  isLoading: boolean;
  isSelected?: boolean;
  enabled?: boolean;
  onClick?: () => void;
}

const ResidentMetricCard: React.FC<IResidentMetricCardProps> = ({
  title,
  description,
  metricValue,
  metricPercent,
  tagType,
  isLoading,
  isSelected = false,
  enabled = true,
  onClick: onClickCallback = () => {}
}) => {
  return (
    <div
      className={classNames(
        "metric-card ",
        {selected: isSelected},
        {disabled: !enabled}
      )}
      onClick={() => (enabled ? onClickCallback() : {})}
    >
      <div
        className={classNames("title", {
          "disabled-title": !enabled || tagType === "disabled",
          "digital-title": tagType === "digital",
          "system-title": tagType === "system",
          "success-title": tagType === "success",
          "warning-title": tagType === "warning",
          "negative-title": tagType === "negative",
          "neutral-title": tagType === "neutral",
          "light-title": tagType === "light"
        })}
      >
        {title}
      </div>
      <div
        className={classNames("description", {
          "disabled-description": !enabled
        })}
      >
        {description}
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="counts">
          <div
            className={classNames("value", {
              "disabled-value": !enabled
            })}
          >
            {metricValue}
          </div>
          {metricPercent !== undefined ? (
            <div>
              <Tag text={`${metricPercent}%`} type={tagType} />
            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </div>
  );
};

export default ResidentMetricCard;
